// extracted by mini-css-extract-plugin
export default {"hourly":"Hourly_hourly__bMxmk"};